const siteFlash = () => {
	let onTick;
	let clockElement;
	const siteFlashActive = document.getElementById('siteFlash');
	const siteFlashClose = document.getElementById('siteFlashBannerClose');
	const siteFlashCountdown = document.getElementById('countdown');

	const siteFlashClosed = () => {
		siteFlashActive.setAttribute('aria-expanded', 'false');
		siteFlashActive.classList.remove('site-flash--is-open');
		siteFlashActive.classList.add('site-flash--is-closed');
	};

	const siteFlashDisplay = () => {
		const systemTime = siteFlashCountdown.getAttribute('data-content');
		const milliSecondsLeft = getCountdown(systemTime);

		if (milliSecondsLeft < 0) {
			clearInterval(onTick);
			siteFlashClosed();
		} else {
			const formattedValues = formatCountdown(milliSecondsLeft);
			clockElement.innerHTML = displayCountdown(formattedValues);
		}
	};

	if (siteFlashClose) {
		siteFlashClose.addEventListener('click', e => {
			siteFlashClosed();
			document.cookie = 'odTippyTop=true; sameSite=Strict; secure; path=/';
			e.stopImmediatePropagation();
			e.preventDefault();
		});
	}

	if (siteFlashCountdown) {
		siteFlashCountdown.classList.add('site-flash__countdown-time--is-visible');
		clockElement = siteFlashCountdown.querySelector(
			'.site-flash__countdown-time',
		);
		onTick = setInterval(siteFlashDisplay, 1000);
	}
};

export default siteFlash;

export const getCountdown = systemTime => {
	const now = new Date();
	const nowUTC = now.toUTCString();
	const localTime = Date.parse(nowUTC);
	return systemTime - localTime;
};

export const formatCountdown = milliSecondsLeft => {
	const hours = Math.floor(
		(milliSecondsLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
	);
	const minutes = Math.floor(
		(milliSecondsLeft % (1000 * 60 * 60)) / (1000 * 60),
	);
	const seconds = Math.floor((milliSecondsLeft % (1000 * 60)) / 1000);
	return { hours, minutes, seconds };
};

export const displayCountdown = times => {
	const { hours, minutes, seconds } = times;

	function dd(n) {
		return (n < 10 ? '0' : '') + n;
	}

	return ` ${dd(hours)} : ${dd(minutes)} : ${dd(seconds)}`;
};
